module.exports = __webpack_public_path__ + "img/mortgagePromo-mob.c4aadefb.jpg";